/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { Collapse, NavItem, NavLink, Button } from 'reactstrap';

import classNames from 'classnames';

function SubMenu(props) {
  const [collapsed, setCollapsed] = useState(true);
  const [forceUpdate, setForceUpdate] = useState(0);
  const { icon, name, items, isOpen } = props;
  const location = useLocation();
  const params = useParams();

  const toggle = () => {
    setCollapsed(!collapsed);
    // Force re-render for Safari compatibility
    setForceUpdate((prev) => prev + 1);
  };

  // Safari compatibility: force re-render when location changes
  useEffect(() => {
    setForceUpdate((prev) => prev + 1);
  }, [location.pathname]);

  // Check if any submenu item is active
  const isActive = items.some((item) => location.pathname === item.to || `${location.pathname}` === `${item.to}/${params.id}`);

  return (
    <div className="submenu-container" key={forceUpdate}>
      <NavItem
        onClick={toggle}
        className={classNames('items-menu d-flex justify-content-between align-items-center', {
          'menu-open': !collapsed,
          active: isActive,
        })}
      >
        <NavLink className="w-100 dropdown-toggle">
          <i className={`${icon} mr-2`} />
          <span className={classNames({ 'd-none': !isOpen })}>{ name }</span>
        </NavLink>
        <Button
          className={classNames('btn-chevron', { 'd-none': !isOpen })}
          color="link"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            toggle();
          }}
        >
          <i className={classNames('fa-solid', {
            'fa-chevron-down': collapsed,
            'fa-chevron-up': !collapsed,
          })}
          />
        </Button>
      </NavItem>
      <Collapse
        isOpen={!collapsed}
        navbar
        className="submenu-collapse"
        timeout={200}
      >
        {items.map((item, index) => (
          <NavItem
            key={`${item.to}-${index}-${forceUpdate}`}
            className={classNames('submenu-item', {
              active: location.pathname === item.to || `${location.pathname}` === `${item.to}/${params.id}`,
            })}
          >
            <NavLink
              className="w-100"
              tag={Link}
              to={item.to}
            >
              <i className={`${item.icon} mr-2`} />
              <span className={classNames({ 'd-none': !isOpen })}>{ item.name }</span>
            </NavLink>
            <Button
              className={classNames({ 'd-none': !isOpen })}
              color="link"
              tag="a"
              target="_blank"
              href={`${process.env.REACT_APP_URL}${item.to}`}
            >
              <i className="fa-solid fa-arrow-up-right-from-square" />
            </Button>
          </NavItem>
        ))}
      </Collapse>
    </div>
  );
}

export default SubMenu;
